import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import BgImg from "../../../images/landing/software-app-development/yeepy-back.webp";
import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";

function Yeppycase() {
  return (
    <section
      className="casestudy-lp yeppy-case text_white"
      style={{ background: "#000" }}
    >
      <Container>
        <div
          className="case-box"
          style={{
            backgroundImage: `url(${BgImg})`,
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
          }}
        >
          <Row>
            <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="offset-md-6">
              <h2>
                Super App <span>Yeppy</span> All Your Needs, One App!
              </h2>
              <p>
                Financial services were consistently used more frequently and
                for longer durations than other features. Users often accessed
                this section to manage their finances, check balances, and make
                transactions.
              </p>
              <Link
                style={{ background: "#f47a14", color: "#fff" }}
                href="#getform"
                className="border_btn"
                aria-label="TekRevol Contact"
              >
                View Case Study
              </Link>
            </Col>
          </Row>
          <Row className="mt-3 mt-md-4">
            <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
              <StaticImage
                src="../../../images/landing/software-app-development/yeppy-img.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={741}
                height={388}
              />
            </Col>
          </Row>
        </div>
      </Container>
    </section>
  );
}

export default Yeppycase;
